'use strict';
import './component.scss';

function isAcceptJavaScript() {
    const acceptJavaScript = sessionStorage.getItem('acceptJavaScript');

    const action = document.querySelector('.recommended-actions');
    if (action !== null) {
        if (acceptJavaScript === 'true') {
            action.style.display = 'none';
        }
    }
}
window.addEventListener('DOMContentLoaded', isAcceptJavaScript);
